module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8671/img/blobsRight.png"